import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PasswordError from './PasswordError';
import PasswordResetForm from './PasswordResetForm';
import { getUrlParam } from '../../utils/url';
import ForgotPasswordForm from './ForgotPasswordForm';
import { CLASS_LOGO_PATH } from '../../config/apiPaths';

const Container = styled.div`
    max-width: 450px;
    margin: 2rem auto 0;
    padding: 4rem;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

const Title = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
    font-size: 24px;
`;

const ImageWrapper = styled.div<{ imageUrl: string }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 175px;
    height: 58px;
    margin: 0 auto 2rem;
    background: transparent url(${(props) => props.imageUrl}) no-repeat center;
    background-size: contain;
`;

const Subtext = styled.div`
    margin-bottom: 1rem;
`;

export interface PasswordResetProps {

}

const PasswordResetPage: React.FC<PasswordResetProps> = () => {
    const { t } = useTranslation('password_reset');
    const token = getUrlParam('token');

    if (!token) {
        return (
            <Container>
                <ImageWrapper imageUrl={CLASS_LOGO_PATH} />
                <Title>{t('trouble-logging-in')}</Title>
                <Subtext>{t('enter-your-email')}</Subtext>
                <PasswordError />
                <ForgotPasswordForm />
            </Container>
        );
    }

    return (
        <Container>
            <ImageWrapper imageUrl={CLASS_LOGO_PATH} />
            <Title>{t('reset-your-password')}</Title>
            <Subtext>{t('enter-new-password')}</Subtext>
            <PasswordError />
            <PasswordResetForm />
        </Container>
    );
};

export default PasswordResetPage;
